import type { Locale } from "@/lib/i18n";
import { pl, type WUserAccountTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const wUserAccountTranslations: Record<Locale, WUserAccountTranslations> = {
  pl,
  en,
  de,
};

export type { WUserAccountTranslations };
